import {
  GET_ACCOUNT_LIST_DATA, SAVE_ACCOUNT_LIST_DATA, DELETE_ACCOUNT, SEND_ACCOUNT_NOTIFICATION,
} from '../../../constants/system/actions';

const getAccountListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_ACCOUNT_LIST_DATA, payload, resolve, reject,
});

const saveAccountListData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_ACCOUNT_LIST_DATA, payload, resolve, reject,
});

const deleteAccount: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: DELETE_ACCOUNT, payload, resolve, reject,
});

const sendAccountNotification: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SEND_ACCOUNT_NOTIFICATION, payload, resolve, reject,
});

export {
  getAccountListData,
  saveAccountListData,
  deleteAccount,
  sendAccountNotification,
};
